import { apiUrl } from '../config/api';
import { apiFetch } from './client';

const API_BASE = apiUrl('/api/admin');

function withPath(path) {
  return `${API_BASE}${path}`;
}

function extractDetail(error, fallback) {
  const detail = error?.detail;
  if (!detail) return fallback;
  if (Array.isArray(detail)) return detail.map(e => e.msg || JSON.stringify(e)).join(', ');
  return String(detail);
}

// ========== Utilisateurs ==========

export async function getAllUsers() {
  const response = await apiFetch(withPath('/users'), {
    auth: true,
  });
  if (!response.ok) {
    throw new Error('Erreur lors du chargement des utilisateurs');
  }
  return response.json();
}

export async function getUserById(userId) {
  const response = await apiFetch(withPath(`/users/${userId}`), {
    auth: true,
  });
  if (!response.ok) {
    throw new Error('Utilisateur non trouvé');
  }
  return response.json();
}

export async function createUser(userData) {
  const response = await apiFetch(withPath('/users'), {
    method: 'POST',
    auth: true,
    json: true,
    body: JSON.stringify(userData),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(extractDetail(error, 'Erreur lors de la création de l\'utilisateur'));
  }
  return response.json();
}

export async function updateUser(userId, userData) {
  const response = await apiFetch(withPath(`/users/${userId}`), {
    method: 'PUT',
    auth: true,
    json: true,
    body: JSON.stringify(userData),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(extractDetail(error, 'Erreur lors de la mise à jour de l\'utilisateur'));
  }
  return response.json();
}

export async function deleteUser(userId) {
  const response = await apiFetch(withPath(`/users/${userId}`), {
    method: 'DELETE',
    auth: true,
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(extractDetail(error, 'Erreur lors de la suppression de l\'utilisateur'));
  }
  return response.json();
}

// ========== Rôles ==========

export async function getAllRoles() {
  const response = await apiFetch(withPath('/roles'), {
    auth: true,
  });
  if (!response.ok) {
    throw new Error('Erreur lors du chargement des rôles');
  }
  return response.json();
}

export async function getRoleById(roleId) {
  const response = await apiFetch(withPath(`/roles/${roleId}`), {
    auth: true,
  });
  if (!response.ok) {
    throw new Error('Rôle non trouvé');
  }
  return response.json();
}

export async function createRole(roleData) {
  const response = await apiFetch(withPath('/roles'), {
    method: 'POST',
    auth: true,
    json: true,
    body: JSON.stringify(roleData),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(extractDetail(error, 'Erreur lors de la création du rôle'));
  }
  return response.json();
}

export async function updateRole(roleId, roleData) {
  const response = await apiFetch(withPath(`/roles/${roleId}`), {
    method: 'PUT',
    auth: true,
    json: true,
    body: JSON.stringify(roleData),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(extractDetail(error, 'Erreur lors de la mise à jour du rôle'));
  }
  return response.json();
}

export async function deleteRole(roleId) {
  const response = await apiFetch(withPath(`/roles/${roleId}`), {
    method: 'DELETE',
    auth: true,
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(extractDetail(error, 'Erreur lors de la suppression du rôle'));
  }
  return response.json();
}

export async function getUsersByRole(roleCode) {
  const response = await apiFetch(withPath(`/users/by-role/${roleCode}`), {
    auth: true,
  });
  if (!response.ok) {
    throw new Error('Erreur lors du chargement des utilisateurs par rôle');
  }
  return response.json();
}

export async function updateAdminPlanStatus(planId, statut) {
  const response = await apiFetch(withPath(`/plans/${planId}/status`), {
    method: 'PATCH',
    auth: true,
    json: true,
    body: JSON.stringify({ statut }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(extractDetail(error, 'Erreur lors de la mise à jour du statut du plan'));
  }

  return response.json();
}
